import { Button } from "../ui/Button.jsx";

export function Nav() {
  const { useState, useEffect } = React;
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { href: "#problem", label: "The problem" },
    { href: "#what", label: "What we do" },
    { href: "#how", label: "How it works" },
    { href: "#vision", label: "Our view" },
    { href: "#verticals", label: "Who it's for" },
    { href: "#team", label: "Who we are" },
  ];

  return (
    <nav className={`nav${scrolled ? " scrolled" : ""}`}>
      <div className="container nav-inner">
        <a href="#top" className="brand">
<img className="brand-logo" src="logo.png" alt="NgineRoom" width="145" height="38" />
        </a>
        <div className="nav-links">
          {links.map((l) => (
            <a key={l.href} href={l.href} className="nav-link">{l.label}</a>
          ))}
        </div>
        <div className="nav-cta-wrap">
          <Button variant="ghost" size="sm" href="https://app.ngineroom.ai">Client login</Button>
          <Button variant="primary" size="sm" href="#waitlist">Join the waitlist</Button>
        </div>
      </div>
    </nav>
  );
}
